var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeveltoolCapPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.925 19.33H24.3601V344.504H520.925V19.33Z",
    fill: "#AF0054",
    stroke: "#AF0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.83 209.967V184.141H267.352L241.526 209.967H155.83Z",
    fill: "#FF419C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M378.874 184.141V209.967H310.2L323.113 197.054L336.026 184.141H378.874Z",
    fill: "#FF419C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.413 227.898C235.109 238.072 233.074 255.603 259.37 244.333L323.935 177.42C323.935 177.42 355.631 186.811 356.805 152.768C350.935 152.768 341.544 160.985 341.544 160.985C334.5 159.811 329.805 162.159 329.805 142.203L343.892 131.637C343.892 131.637 303.979 119.898 308.674 162.159L239.413 227.898ZM250.439 227.898C244.569 229.072 241.047 237.29 250.439 240.812C259.83 240.812 259.83 229.072 250.439 227.898Z",
    fill: "#FF419C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeveltoolCapPressed);
export default __webpack_public_path__ + "static/media/leveltool-cap-pressed.22a6db5562a36bc56183aa55af969d78.svg";
export { ForwardRef as ReactComponent };